import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { authKeys } from '@core/react-query/features/auth'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useResetPassword = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['resetPassword']
  >,
) => {
  return useMutation({
    mutationFn: (variables) =>
      authKeys.resetPassword(variables).queryFn(undefined),
    ...options,
  })
}
